import { ROLE_PRINCIPAL_INVESTIGATOR, ROLE_SYSTEM_ADMINISTRATOR } from '../../../../../../../constants/userRoles';

export function isInvestigatorForbiddenField(investigatorField, userRole) {
  return investigatorField && ![ROLE_PRINCIPAL_INVESTIGATOR, ROLE_SYSTEM_ADMINISTRATOR].includes(userRole);
}
